<template>
    <div :id="'radio--' + question" v-if="options_loaded && passed_filter && panel_required">
        <div v-if="!loading" :data-designer-component-id="question" class="stylesoption designer-question-tiled-layout _3-col">
            <div class="tile">
                <span>{{ title }}</span>
            </div>
            <div class="tile">
                <img :src="image_url" class="collection-option-tile-image"/>
            </div>
            <div class="tile">
                <span v-for="option in filtered_option_list" class="full-width"><label><input type="radio" v-model="localTarget"
                                                                           :name="'radio_' + question"
                                                                           :value="option.value"/> {{ option.label }}</label></span>
            </div>
        </div>
        <div v-if="loading">
            <p>Loading Options</p>
        </div>
    </div>
</template>

<script type="text/ecmascript-6">
    import Question from "./mixin/Question.vue";
    import {nextTick} from "vue";

    export default {
        mixins: [
            Question,
        ],
        props: {
            title: {
                default(){
                    return '';
                }
            },
            component_id: {
                default(){
                    return '';
                }
            },
            question: {
                required: true,
            },
            fabricator_name: {
              required: true,
            },
            hardwareHinge: {
              required: false,
              default(){
                return null;
              }
            },
        },
        computed: {
            url(){
                return '/api/options/' + this.fabricator + '/collection?question=' + this.question + '&hardware_hinge=' + this.hardwareHinge;
            },
            cache_key(){
                return '_' + this.question + '_' + this.hardwareHinge;
            },
            image_url(){
                return '/images/'+this.fabricator_name+'/' + this.question + '.png';
            },
            panel_required() {
                return this.filtered_option_list.length > 0;
            }
        },
        watch: {
            'cache_key': function (val, oldVal) {
                this.update_options();
            },
            'filtered_option_list': function (new_val, old_val) {
                nextTick(()=>{
                    var options = $('#radio--' + this.component_id + ' input').not('.icheck').not('.skip_icheck');

                    options.addClass('icheck').iCheck({
                        checkboxClass: 'checkboxstyle',
                        radioClass: 'radiostyle',
                        selectClass: 'selectstyle'
                    });

                    $('.icheck').iCheck('update');

                    options.on('ifChecked', (e) => {
                        this.localTarget = parseInt(e.target.value);
                    });
                });
            }
        }
    }
</script>
